import(/* webpackMode: "eager" */ "/codebuild/output/src1741631747/src/MODERATE-WEB-APP/app/loading.tsx");
